import { LeadInvestorInfoItem, LeadInvestorInfoItemDB, LocalizedText } from 'models/common-types';
import { Types } from 'mongoose';

import { ObjectValues } from 'types/object-values';

export interface IModelDB {
  _id: Types.ObjectId;
  companyId: Types.ObjectId;
  legalName: string;
  about: LocalizedText;
  companySize: string;
  keyInformation: LocalizedText;
  dealTerms: string;
  shortDescription: LocalizedText;
  prevRounds: number;
  investmentTerms: string;
  termsOfDeal: LocalizedText;
  termsOfDealLink: string;
  raised: string;
  raisedFieldLabel: LocalizedText;
  seriesFunding: string;
  investmentStatusTitle: LocalizedText;
  foundersTitle: LocalizedText;
  offerInvestorsTitle: LocalizedText;
  leadInvestorsTitle: LocalizedText;
  investmentStatusColor: string;
  valuation: number | string;
  progressBarPercentage: number;
  isProgressBarVisible: boolean;
  clip: string;
  leadInvestorInfo: Array<LeadInvestorInfoItemDB>;
  documents: Array<{ title: string; file: string }>;
  videoGallery: Array<{ title: string; file: string }>;
  investmentStatus: InvestmentStatus;
  recruitmentTotalAmount: number;
  investmentMinAmount: number;
  investmentOffersDeadline: Date;
  isVisible: boolean;
}

export interface IModel
  extends Omit<
    IModelDB,
    | 'keyInformation'
    | 'about'
    | 'shortDescription'
    | 'termsOfDeal'
    | 'raisedFieldLabel'
    | 'investmentStatusTitle'
    | 'foundersTitle'
    | 'offerInvestorsTitle'
    | 'leadInvestorsTitle'
    | 'leadInvestorInfo'
  > {
  keyInformation: string;
  about: string;
  shortDescription: string;
  termsOfDeal: string;
  foundersTitle: string;
  raisedFieldLabel: string;
  investmentStatusTitle: string;
  offerInvestorsTitle: string;
  leadInvestorsTitle: string;
  leadInvestorInfo: Array<LeadInvestorInfoItem>;
}

export const INVESTMENT_STATUS = {
  OPEN_FOR_INVESTMENTS: 'OPEN_FOR_INVESTMENTS',
  OVER_SUBSCRIBED: 'OVER_SUBSCRIBED',
  INVESTMENT_ENDED: 'INVESTMENT_ENDED',
} as const;

export type InvestmentStatus = ObjectValues<typeof INVESTMENT_STATUS>;
